import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";
import parlors from "@/constants/parlors_detail.json";

import NotFoundPage from "pages/404";
import { FUNERAL_SIGUNGU } from "goi_common";
import { getThreeClosestParlorFrom } from "@/containers/Parlor/ParlorDetailContainer/utils/getThreeClosestParlorFrom";
import dayjs from "dayjs";
import { Box } from "@chakra-ui/react";
import ParlorRequestContainer from "@/containers/Parlor/ParlorRequestContainer";
import { ParlorDetailProps } from "@/types/parlor";

import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;
  if (skipBuildResult) {
    return skipBuildResult;
  }

  const paths = parlors.map((parlor) => ({
    params: {
      id: String(parlor.id),
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = params?.id;
  let parlor;
  let district;
  let sigungu;
  let name = "";
  let description = "";
  let closestParlorsByService = {};

  if (id) {
    parlor = parlors.find((parlor) => parlor.id === Number(id));
    if (parlor) {
      name = parlor.companyname;
      sigungu = FUNERAL_SIGUNGU.get(Number(parlor?.sido))?.get(Number(parlor?.sigungu));
      district = parlor.address.slice(0, 2);
      if (parlor.address.split(" ")[0].length == 4)
        district = parlor.address[0] + parlor.address[2];

      // let binsoString = "";
      // parlor.binsos.forEach((binso: BinsoObject) => {
      //   if (binso.pyeong) {
      //     binsoString += `${binso.pyeong.toFixed()}평형 ${numberToLocalString(binso.charge)}원, `;
      //   }
      // });

      // description =
      //   name +
      //   " 정보 안내," +
      //   " 빈소 평형별 정보 (1일/24시간 기준) - 고이장례연구소 예상 비용(자체 산정)\n" +
      //   binsoString.slice(0, binsoString.length - 2) +
      //   "\n" +
      //   `, 주소:${parlor.address}, 전화번호:${parlor.telephone}. 빈소 평형별 정보 안내`;

      description =
        `${name}(${sigungu})` +
        // " 장례, " +
        // `${name}(${sigungu})` +
        // " 장례식 예상 비용" +
        // `${name}(${sigungu})` +
        // " 3일장 장례 비용, " +
        // `${name}(${sigungu})` +
        // " 평균 장례 비용, " +
        // `${name}(${sigungu})` +
        // " 빈소 유형\n" +
        // binsoString.slice(0, binsoString.length - 2) +
        // "\n" +
        // `${name}(${sigungu})` +
        " - 고이장례연구소 예상 장례 비용(자체 산정) " +
        parlor.expected_charge_sum["무빈소"].toLocaleString() +
        "원 ~ " +
        parlor.expected_charge_sum["일반장"].toLocaleString() +
        "원 " +
        "\n" +
        `장례식장별 비교, 추천, 예상 비용 안내. ${name}(${sigungu}) 포함`;

      closestParlorsByService = {
        무빈소: getThreeClosestParlorFrom(parlor as any, "무빈소"),
        가족장: getThreeClosestParlorFrom(parlor as any, "가족장"),
        일반장: getThreeClosestParlorFrom(parlor as any, "일반장"),
      };
    }
  }

  return {
    props: {
      defaultParlor: parlor,
      pageDescription: description,
      pageKeywords: `${name}(${sigungu}), ${name}(${sigungu}) 장례 비용, ${district} 장례 견적, ${name} 평균 장례 비용`,
      // pageOgTitle: `${name}(${sigungu}) 장례식 예상 비용 - [장례의 모든 것, 고이장례연구소]`,
      pageOgTitle: `${name}(${sigungu}) 포함 장례식 예상 비용, 장례식장별 비교, 추천 - [숨김 없는 장례의 시작, 고이]`,
      pageOgDescription: description,
      pageOgImage: parlor?.images[0]?.url || `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png`,
      hasError: !parlor,
      closestParlorsByService,
      // 네이버는 사이트당 웹문서 1개만 노출한다. 견적폼이 상세의 자리를 뺏지 않도록 상세로 몬다
      pageCanonical: parlor ? `https://www.goifuneral.co.kr/parlor/${parlor.id}/` : null,
    },
  };
};

function ParlorRequest({
  defaultParlor,
  hasError,
}: {
  defaultParlor: ParlorDetailProps;
  hasError: boolean;
}) {
  // const { howtoRichSearch, carouselRichSearch, reviewResult76 } = richSearchData.parlor;
  // const { faqList, reviewResult } = richSearchData.common;
  if (hasError) return <NotFoundPage />;
  const today = dayjs().format("YYYY-MM-DD");
  return (
    <>
      <Box position="absolute" marginTop="-90px">
        <time dateTime={today} className="white se_publishDate pcol2 date">
          {today}
        </time>
      </Box>

      {/* <RichSearch key="faqs" data={faqList} />
      <RichSearch key="howto" data={howtoRichSearch} />
      <RichSearch key="carousel" data={carouselRichSearch} /> */}
      {/* <RichSearch
        key="review"
        data={String(defaultParlor.id) === "76" ? reviewResult76 : reviewResult}
      /> */}
      <ParlorRequestContainer parlor={defaultParlor} />
    </>
  );
}

export default ParlorRequest;
